import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Tailles de police et ombres issues des tokens (text-small, text-h1…, shadow-e1…) : déclarées pour que
// tailwind-merge ne les confonde pas avec des couleurs (text-success) et ne supprime pas l'une des deux classes.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['kpi', 'h1', 'h2', 'h3', 'h4', 'body', 'body-mobile', 'small', 'input-mobile'] }],
      shadow: [{ shadow: ['e1', 'e2', 'e3', 'e4'] }],
    },
  },
});

/** Fusion de classes Tailwind (les classes suivantes l'emportent). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
